import type { EnvCms } from '@bcf-vanilla-ts-v1-api-access/config-tokens/env-cms';
import type { EnvCp } from '@bcf-vanilla-ts-v1-api-access/config-tokens/env-cp';
import type { EnvFe } from '@bcf-vanilla-ts-v1-api-access/config-tokens/env-fe';
import type { EnvCommon } from '@bcflit-env/types';
import { envBaseCommon } from './env.base';

export const envCp: EnvCp = {
  userApiUrl: 'https://user.januszcasino{apiVersion}.com/',
  walletApiUrl: 'https://wallet.januszcasino{apiVersion}.com/',
  paymentApiUrl: 'https://payment.januszcasino{apiVersion}.com/',
  cpSocketUrl1: 'wss://ws.januszcasino{apiVersion}.com/register'
};

export const envCms: EnvCms = {
  cmsApiUrl: 'https://cms.januszcasino{apiVersion}.com/'
};

export const envFe: EnvFe = {
  feApiUrl: 'https://januszcasino{apiVersion}.com'
};

// // eslint-disable-next-line @typescript-eslint/typedef
export const envCommon: EnvCommon = {
  ...envBaseCommon
};
